import { toast } from "sonner";

function isUnhelpfulMessage(msg) {
  if (typeof msg !== "string" || !msg.trim()) return true;
  const text = msg.trim();
  if (/^cannot\s+(get|post|put|patch|delete)\s+/i.test(text)) return true;
  if (/^request failed with status code\s+\d+/i.test(text)) return true;
  if (text.startsWith("<")) return true;
  return false;
}

/**
 * Extract a human-readable message from an API error or string.
 */
export function getErrorMessage(errOrMessage, fallback = "Something went wrong") {
  if (errOrMessage == null || errOrMessage === "") return fallback;
  if (typeof errOrMessage === "string") {
    return isUnhelpfulMessage(errOrMessage) ? fallback : errOrMessage;
  }
  const apiMsg = errOrMessage?.response?.data?.message;
  if (typeof apiMsg === "string" && !isUnhelpfulMessage(apiMsg)) return apiMsg;
  if (Array.isArray(apiMsg) && apiMsg.length) {
    const joined = apiMsg.map(String).join(", ");
    if (!isUnhelpfulMessage(joined)) return joined;
  }
  if (
    typeof errOrMessage?.response?.data === "string" &&
    !isUnhelpfulMessage(errOrMessage.response.data)
  ) {
    return errOrMessage.response.data.trim();
  }
  if (
    typeof errOrMessage?.message === "string" &&
    !isUnhelpfulMessage(errOrMessage.message)
  ) {
    return errOrMessage.message;
  }
  return fallback;
}

export function toastSuccess(message) {
  return toast.success(String(message || "Done"));
}

export function toastError(errOrMessage, fallback) {
  return toast.error(getErrorMessage(errOrMessage, fallback));
}

export function toastMessage(message) {
  return toast.message(String(message || ""));
}

export { toast };
